module.exports = __webpack_public_path__ + "static/media/ic_date.2a6456b4.svg";